const SERVICE_DATA = {
    heading: "Our Services",
    description: "",
    services_list: [{
            label: "Windows Installation",
            text: "Our construction team will manage all window installation details from start to finish. It takes field experience and talent to pull off a big exterior installation.",
            icon: "pe-7s-photo-gallery"
        },
        {
            label: "Demolition",
            text: "We have a highly skilled team ready to fulfill all demolition projects, including everything from bathroom demolition to kitchen demolition plus full removal of all materials to the landfill which may include any trash left inside",
            icon: "pe-7s-hammer"
        },
        {
            label: "Exterior Door Installation",
            text: "Our team has the best experience, providing solutions for your needs when it comes to entry doors, patio doors, and even sliding doors",
            icon: "pe-7s-phone"
        },
        {
            label: "Vinil Siding Installation",
            text: "It is a paradisematic country, in which roasted parts of sentences fly into your mouth leave for the far World.",
            icon: "pe-7s-culture"
        },
        {
            label: "Roofing",
            text: "Our team has a full range of services for the installation of new roofs, roof maintenance, roof repairs and re-roofing services'",
            icon: "pe-7s-home"
        },
        {
            label: "Trim installation",
            text: "If you and need vinyl siding installed, replaced or you want to repair a piece of siding that is warped. Our vinyl siding installation specialists are ready to help",
            icon: "pe-7s-battery"
        },
        {
            label: "Fencing",
            text: "Give your property a unique look with a properly installed fence that does the job. We install and repair fences.",
            icon: "pe-7s-map"
        },
        {
            label: "Exterior painting",
            text: "Our professional house painters have the knowledge, experience and tools to do the job. Forget about faded and drab exterior paint or those flaking areas that look shabby.",
            icon: "pe-7s-paint"
        }
    ]
};

const EXPERIENCE_DATA = {
    title: 'A professional service for remodeling and construction projects',
    text: 'With 10 years of experience Estradas Brothers directly serve all your remodeling or construction needs. We are a local company that does direct to client business, no intermediary. You deal directly with the professional workers that will be at your site doing the job',
    feature_list: [
        'We put a lot of effort in our job.',
        'The most important ingredient of successful work is attention to the details.',
        'We adapt to our customer needs.',
        'Submit your wish letter, we can help!'
    ]
};

const PRICING_DATA = {
    title: 'Our Pricing',
    description: '',
    pricing_list: [
        {
            title: 'Roof installation',
            price: '$20.00',
            material: 'not included',
            space: 'sqft',
            availability: 'Immediately',
            site: 1
        },
        {
            title: 'Siding installation',
            price: '$25.00',
            material: 'not included',
            space: 'sqft',
            availability: 'Immediately',
            site: 1
        },
        {
            title: 'Painting',
            price: '$20.00',
            material: 'not included',
            space: 'sqft',
            availability: 'Immediately',
            site: 1
        }
    ]
};

const TEAM_DATA = {
        title: 'Our Expert Team',
        description: 'It is a long established fact that construction and remodeling projects need experienced workers. That is why we decided to start this enterprise to offer our customers this experience first hand, without any sales man in the middle. Real work for real and fare price.',
        team_list: [
            {
                profile: '/images/team/img-1.jpg',
                name: 'Carmelo Escogido Estrada',
                designation: 'Lead contructor'
            },
            {
                profile: '/images/team/img-2.jpg',
                name: 'Francisco Herrera',
                designation: 'Roof installation expert'
            },
            {
                profile: '/images/team/img-3.jpg',
                name: 'Juan Escogido Estrada',
                designation: 'Tooling and heavy machinery'
            },
            {
                profile: '/images/team/img-4.jpg',
                name: 'Ana Lorena Herrera',
                designation: 'Design and schedule manager'
            }
        ]
}

const TESATIMONIAL_DATA = {
    title :"What they've said",
    description: "TESTIMONIALS",
    testimonial_list: [
        {
            profile: 'images/testimonials/user-3.jpg',
            description: "Very hard working people. I was surprised about the little time they took to get the job done. We are continuosly hiring their services",
            name: 'Paloma Pressler - ',
            text: 'The Arbor Columbus Apartments (General Manager)'
        },
        {
            profile: 'images/testimonials/user-1.jpg',
            description: "Estrada Brother's are amazing. We just wanted to fix a gutter but we saw their excellent job and fare pricing. We ended with a package of siding maintenance, paint, and they also fixed our basement crawl space insulation.",
            name: 'Gabriel Escamilla - ',
            text: 'Dublin OH.'
        },
        {
            profile: 'images/testimonials/user-2.jpg',
            description: "Other companies gave me high estimates and they wanted to change the whole thing in my roof. Estradas construction fixed what was needed and now I have all my gutters cleaned and a fascia board replaced.",
            name: 'Theresa D. Sinclair - ',
            text: 'Canal Winchester'
        }
    ]
}

const BLOG_DATA = {
    title :'Blog',
    description: 'We are fast and we are good in what we do because we are there where you need us when you need us.',
    blog_list:[
        {
            image: 'images/blog/img-1.jpg',
            text: 'Interiors',
            title: 'Demolition, paint, remodeling...',
            subtext: 'We undertake every project with attention to quality, cost and time'
        },
        {
            image: 'images/blog/img-2.jpg',
            text: 'Roofing',
            title: 'We are on top of it',
            subtext: 'We have roof repair and replacement experts, specializing in gutter repair, storm damage, and general roof issues'
        },
        {
            image: 'images/blog/img-3.jpg',
            text: 'Exterior',
            title: 'New construction and remodeling',
            subtext: 'Sometimes your exterior siding only requires a minor repair, like patching a hole or crack. Sometimes you are more interested in replacement or a new construction siding.'
        }
    ]
}

const MOCK_DATA = {
    SERVICE_DATA,
    EXPERIENCE_DATA,
    PRICING_DATA,
    TEAM_DATA,
    TESATIMONIAL_DATA,
    BLOG_DATA
}

export default MOCK_DATA;